import React from 'react';
import Helmet from 'react-helmet';
import { useIntl } from 'react-intl';
import { Status } from '../../../_universal';
import ErrorMessage from '../ErrorMessage';
import DiLayout from './DiLayout';

export default function DiErrorPage({ errorDetails, size = 'sm' }) {
  const intl = useIntl();
  const title = intl.formatMessage({
    id: 'DiLayout.DiErrorPage.title',
    defaultMessage: 'Error…',
  });
  return (
    <DiLayout size={size}>
      <Status statusCode={500} />
      <Helmet>
        <title>{title}</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <ErrorMessage errorDetails={errorDetails} marginTop="xl" />
    </DiLayout>
  );
}
